import React from 'react';

const projectCardContent =[
  {
    title: "Weather by BOM",
    diciplines: ["Code", "Design", "Illustration"],
    pagelink: ""
  },
  {
    title: "Weather by BOM",
    diciplines: ["Code", "Design", "Illustration"],
    pagelink: ""
  }
];

const ProjectCard1x2 = ({title, diciplines, pagelink}) => (
  <div>
  {projectCardContent.map(item =>
    <div className="col col-1 col-1-2--m">
      <div className="bg-photo placeholder-4 overlay">
        <div className="hero hero--s hero__inner">
          <h1 className="shout">{title}</h1>
          <ul className="list-inline disciplines">
            {item.diciplines.map(item => (
              <li>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )}
  </div>
);

export default ProjectCard1x2;



// WEBPACK FOOTER //
// ./src/layout/portfolio/ProjectCard1x2.js